export default "/Resources/9d7538c410524f24ddc05257d27f5f76.svg";